import './styles/carousel.css';
import focusSettings from './../Focus/settings';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import getAppConfig from '../../config/appConfig';
import Badges from './../../requests/apa/Badges';
import { withRouter } from 'react-router-dom';
import Device from '../../devices/device';
import DeviceStorage from '../DeviceStorage/DeviceStorage';

/** Utils **/
import Utils, {handleToggleShowHeadBrand} from '../../utils/Utils';
import GeneralRibbonUtils from './GeneralRibbonUtils';
import RibbonsUtil from '../../utils/RibbonsUtil';

/** Constants **/
import {
  HIGHLIGHT,
  CATEGORY,
  PREMIUM,
  MORETOP,
  MOREPOPULAR,
  RECORDINGS,
  LEFT,
  RIGHT,
  UP,
  TALENTS,
  LIVECHANNEL,
  VOID,
  MUNDIALSOCCERMATCHER,
  MUNDIALSOCCERTEAMS,
  MUNDIALPLAYERS,
  VCARDMATCH,
  DOWN,
  LASTVIEWEDCHANNELS,
  LIVEEVENTSCHANNELS
} from './constants';
/** Ribbon Types **/
import RibbonClassic from './RibbonTypes/RibbonClassic';
import RibbonHighlight from './RibbonTypes/RibbonHighlight';
import RibbonPremium from './RibbonTypes/RibbonPremium';
import RibbonCategories from './RibbonTypes/RibbonCategories';
import RibbonRecordings from './RibbonTypes/RibbonRecordings';
import RibbonTop from './RibbonTypes/RibbonTop';
import RibbonPopular from './RibbonTypes/RibbonPopular';
import RibbonTalent from './RibbonTypes/RibbonTalent';
import RibbonLiveChannel from './RibbonTypes/RibbonLiveChannel';
import RibbonVoid from './RibbonTypes/RibbonVoid';

//Mundial
import RibbonTeams from '../../mundial/RibbonTypes/RibbonTeams/RibbonTeams'
import RibbonMatcher from '../../mundial/RibbonTypes/RibbonMatchers/index'
import RibbonSoccerPlayer from '../../mundial/RibbonTypes/RibbonsPlayers/index'

import { playFullMedia } from '../../actions/playmedia';
import LayersControl from '../../utils/LayersControl';
import { HIDE_MODAL, MODAL_RECORD_SERIES_CONTENT } from "../../actions/modal";
import AAFPlayer from "../../AAFPlayer/AAFPlayer";
import { AAFPLAYER_PLAY } from "../../AAFPlayer/constants";
import { LIVE_PLAY_FROM_HOME } from '../../AAFPlayer/helpers/ThirdPartyEpgHelper';
import ChannelSingleton from '../Epg/ChannelsSingleton';
import store from "../../store"
import { navigationUpSoccer } from './functions.mundial';
import PlayerStreamingUtils from 'src/utils/PlayerStreamingUtils';
import asyncPinObserver from '../../AAF/Pin/AsyncPinObserver';
import { SetValueElementMouseEnter } from '../PersistentMiniEpg/MiniObserver';
import RibbonLastViewedChannels from './RibbonTypes/RibbonLastViewedChannels';
import RibbonLiveEventsChannels from './RibbonTypes/RibbonLiveEventsChannels';
import {scrollToRibbon} from "../RibbonGridNew/PS4/PS4RibbonScrolling";
import {transformTextToCreateID} from "../RibbonGridNew/utis";
import { LINKED, ACTIVATION_FLOW, HBO } from "src/components/RibbonNew/constants.js";
import { resolveIsHBOActivation } from 'src/utils/Utils';
import logger from 'src/utils/logger/logger';
import {
  isContinueWatchingRibbon,
  trackContinueWatchingRendered,
  trackContinueWatchingScrolled,
} from '../../services/datadog/continueWatching';

let continueWatchingRenderedRoute = null;
let hasTrackedContinueWatchingRendered = false;

function updateContinueWatchingRenderedRoute(location = {}) {
  const pathname = location.pathname || '';

  if (continueWatchingRenderedRoute !== pathname) {
    continueWatchingRenderedRoute = pathname;
    hasTrackedContinueWatchingRendered = false;
  }
}

class Ribbon extends Component {
  constructor(props) {
    super(props);
    this.items= []
    this.isMusic = !!(this.props && this.props.match && this.props.match.params && this.props.match.params.code && this.props.match.params.code === 'claromusica');

    this.ribbonId = this.isMusic
      ? (transformTextToCreateID(this.props.id) || `cv-${new Date().getTime()}`)
      : (this.props.id ||`cv-${new Date().getTime()}`);

    this.config = getAppConfig();
    this.region = (props.user && props.user.region) || DeviceStorage.getItem('region');
    this.ribbons_show_delete_button = Utils.getRegionaliazedMetadata('ribbons_show_delete_button', '{"default":{"lastseen":{"enable":true,"type":["Actividad-reciente","actividadreciente","Continua-viendo","continuaviendo", "Recien-visto"]},"favorite":{"enable":true,"type":["Por-ver","porver","porver-live","porver-vod"]}}}');

    this.userType = 'anonymous';
    this.ribbonType = this.props.type;
    this.keys = Device.getDevice().getKeys();
    this.data = null;
    this.carruselTitle =
      typeof props.carruselTitle !== 'undefined' ? props.carruselTitle : props.title;
    if (props.user.isLoggedIn) {
      this.userType = props.user.isSusc ? 'susc' : 'no_susc';
    }
    this.visibleNumber = GeneralRibbonUtils.getVisibleNumber({ type: props.type, visibleNumber: props.visibleNumber, isMusic: this.isMusic});
    this.placesMovingToLeft = GeneralRibbonUtils.getPlacesMovingToLeft(props.type);
    this.state = {
      items: GeneralRibbonUtils.getVisibleItems(this.getFilteredItems(props.items, props.type), this.visibleNumber, this.placesMovingToLeft)
    };
    this.isRecentActivity = false;
    this.isModalRecordSerie = props.code === "series";
   if (
      (this.ribbons_show_delete_button.lastseen && this.ribbons_show_delete_button.lastseen.enable && this.ribbons_show_delete_button.lastseen.type.includes(this.ribbonId))
      || (this.isModalRecordSerie && this.ribbons_show_delete_button.lastseen && this.ribbons_show_delete_button.lastseen.enable && this.ribbons_show_delete_button.lastseen.type.includes(this.props.type))
    ) {
      this.isRecentActivity = true;
    }
    this.fastNavigationInterval = 500;
    this.platform = Device.getDevice().getPlatform();

    this.getDirection = this.getDirection.bind(this);
    this.focusHandler = this.focusHandler.bind(this);
    this.clickHandler = this.clickHandler.bind(this);
    this.hideTopRibbons = this.hideTopRibbons.bind(this);
    this.showTopRibbons = this.showTopRibbons.bind(this);
    this.badgesUserType = {};

    if (Badges.data && Badges.data[this.userType]) {
      this.badgesUserType = Badges.data[this.userType];
    }
    this.isModalRecordSeriesContent = Utils.modalType() === MODAL_RECORD_SERIES_CONTENT;
    this.noFocusDynamicBox = ["highlight", "Superdestacado", "planselector"];
    // Suscripción se hace en componentDidMount para evitar duplicados
    this.elementoConPuntero = null;
    this._previousFocused = null;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.items && nextProps.items && this.props.items[0] !== nextProps.items[0]) {
      this.visibleNumber = GeneralRibbonUtils.getVisibleNumber({ type: nextProps.type, visibleNumber: nextProps.visibleNumber });
      const filteredItems = this.getFilteredItems(nextProps.items, nextProps.type);
      const newItems = GeneralRibbonUtils.getVisibleItems(filteredItems, this.visibleNumber, this.placesMovingToLeft);
      this.setState({
        items: newItems
      });
    }
  }

  getDirection(e) {

    if (!e.detail.direction || this.isModalRecordSerie) {
      return null;
    }
    const direction = e.detail.direction.toUpperCase();
    this.arrowHandler(direction, e);
  }

  focusHandler(data) {
    const focused = document.activeElement;
    if( this.elementoConPuntero === focused.id){
      logger.debug('El hover y el foco estan sobre el mismo elemento - Son iguales');
      return;
    }

    this.elementoConPuntero = null;
    this.data = data;

    // Limpiar listener del elemento anterior para evitar acumulación
    if (this._previousFocused && this._previousFocused !== focused) {
      this._previousFocused.removeEventListener('sn:willmove', this.getDirection);
    }
    this._previousFocused = focused;
    focused.removeEventListener('sn:willmove', this.getDirection);
    focused.addEventListener('sn:willmove', this.getDirection);


    if (this.refs && this.refs[this.ribbonId]) {
      //this.fixTopVerticalRibbon(this.refs[this.ribbonId]);
      //this.refs[this.ribbonId].scrollIntoView(false);
      this.validationOnLastRibbonElement(this.ribbonId);
    }
    if (typeof this.props.focusHandler === 'function') {
      this.props.focusHandler(data, this.ribbonId);
    }
    this.data = data;

    if (this.props.onHandleFocusEpisodes) {
      this.props.onHandleFocusEpisodes(this.data);
    }
  }


  fixTopVerticalRibbon(ribbon){
    //Este metodo ya no se usa la logica se unifico en validationOnLastRibbonElement
    const ribbonPopular = ribbon.querySelector('.ribbon-items.ribbon-popular');
    if (!ribbonPopular){
      const verticalRibbons = document.getElementsByClassName('ribbon-items ribbon-popular');
      for (const ribbon of verticalRibbons) {
        const { top } = ribbon.getClientRects()[0] || {}
        const ribbonContainer = this.getNParent(ribbon, 4);
        if (top < 0 && top > -50) {
           ribbonContainer.style.display = "none";
        }
        else
        {
          ribbonContainer.style.display = "";
        }
      }
    }
  }

  validationOnLastRibbonElement(ribbonId){
    // En PS4 la virtualización ya maneja la visibilidad de ribbons
    if (this.platform === 'ps4') return;

    const lastRibbon = Utils.getLastRibbonName();

    if (lastRibbon === ribbonId){
      //this.refs[ribbonId].scrollIntoView(false);
      return;
    } else {
      Utils.setLastRibbonName(ribbonId)
    }


    const currentRibbon = document.getElementById(ribbonId);
    if (currentRibbon){
      const parentRibbon = this.getNParent(currentRibbon, 2);
      //logger.error('GCR currentRibbon is: ', ribbonId, currentRibbon.clientHeight, parentRibbon.classList.value)
      if (parentRibbon.classList.contains('last-ribbon') || parentRibbon.classList.contains('last-ribbon-landscape')){
        handleToggleShowHeadBrand('show');
        this.hideTopRibbons();
      }else if (parentRibbon.classList.contains('last-but-one-ribbon') || parentRibbon.classList.contains('last-but-one-ribbon-landscape')){
        const previousRibbon = this.getNPreviousSibling(parentRibbon, 1);
        this.hideTopRibbons();
        this.showPreviousRibbon(previousRibbon);
      }else if (parentRibbon.classList.contains('last-but-two-ribbon') || parentRibbon.classList.contains('last-but-two-ribbon-landscape')){
        const twoPreviousRibbon = this.getNPreviousSibling(parentRibbon, 2);
        if (twoPreviousRibbon && this.isRibbonHidden(twoPreviousRibbon)){
          handleToggleShowHeadBrand('hide');
          this.showTopRibbons()
        }
        else {
          const previousRibbon = this.getNPreviousSibling(parentRibbon, 1);
          handleToggleShowHeadBrand('hide');
          if (this.isRibbonHidden(previousRibbon)){
            this.showTopRibbons()
          }
        }
      }
      //MUNDIAL
     if(this.props && this.props.location && this.props.location.pathname && this.props.location.pathname.search(VCARDMATCH) >= 0){
      this.refs[ribbonId].scrollIntoView(true);
     } else{
      this.refs[ribbonId].scrollIntoView(false);
     }
    }
  }

  hideTopRibbons(){
    let topRibbons = document.getElementsByClassName('top-ribbon');
    let scrollerContainer = document.querySelector("#slider-grid-movies .scroller-container");

    if (this.isModalRecordSeriesContent) {
      scrollerContainer = document.querySelector('.scrollabe-container-modal-series-content');
      topRibbons = scrollerContainer.getElementsByClassName('top-ribbon');
    }

    Array.from(topRibbons).forEach(function(topRibbon) {
      this.hideRibbon(topRibbon);
    }.bind(this));
    scrollerContainer.style.marginTop = '0px';
  }

  showTopRibbons(){
    Array.from(document.getElementsByClassName('top-ribbon')).forEach(function(topRibbon) {
      this.showRibbon(topRibbon);
    }.bind(this));

    const ribbonContainer = document.querySelector("#slider-grid-movies .scroller-container");
    ribbonContainer.style.marginTop = `-${Utils.getMaxRibbonMarginTop()}px`;

  }

  isRibbonHidden(ribbon){
    if (ribbon && ribbon.style && ribbon.style) {
      return ribbon.style.display === "none";
    }
    return null;
  }

  showRibbon(ribbon) {
    if (ribbon && ribbon.style) {
      ribbon.style.display = "";
    }
  }

  hideRibbon(ribbon){
    if (ribbon && ribbon.style) {
      ribbon.style.display = "none";
    }
  }

  showPreviousRibbon(previousRibbon){
    if (this.isRibbonHidden(previousRibbon)) {
      this.showRibbon(previousRibbon)
    }
  }

  hideRibbonIfNegative(ribbon){
    const { top } = ribbon.getClientRects()[0] || {}
    if (top < 0) {
     this.hideRibbon(ribbon);
    }
  }

  getNParent(element, n){

    let parent = element, i= 0;
    while (i < n) {
      if (parent){
        parent = this.getParent(parent);
      }
      i++;
    }
    return parent;
  }

  getNPreviousSibling(element, n){
    let sibling = element, i= 0;

    while (i < n) {
      if (sibling){
        sibling = this.getPreviousSibling(sibling);
      }
      i++;
    }
    return sibling;
  }

  getParent(element) {
    if(element.parentNode){
      return element.parentNode;
    }
    return null;
  }

  getPreviousSibling(element) {
    if(element.previousElementSibling){
      return element.previousElementSibling;
    }
    return null;
  }

  tryCloseModal() {
    if (!Utils.isModalHide()) {
      if (AAFPlayer.getCurrentPlayingState(false) === AAFPLAYER_PLAY) {
        store.dispatch({
          type: HIDE_MODAL
        });
      } else {
        setTimeout(() => {
          this.tryCloseModal();
        }, 100);
      }
    }
  }

  async clickHandler(data, isChannelOrRecordingBlocked) {
    const { ribbonId = null } = this;
    const { group_id = null } = data;
    if (data && data.filterTV && data.group_id) {
        // LOGICA CUANDO EL CARROUSEL EN HOME SON FILTROS DE GUIA DE TV
        let filterGroupid = null;
        new ChannelSingleton()
            .getFilteredChannels(data.group_id)
            .then(async (availableChannels) => {
                if (availableChannels && Array.isArray(availableChannels)) {
                    for (let i = 0; i < availableChannels.length; i++) {
                      // OBTENIENDO EL PRIMER CANAL QUE SE PUEDA REPRODUCIR.
                        if (availableChannels[i].group_id && ChannelSingleton.canPlayChannel(availableChannels[i].group_id)) {
                            filterGroupid = availableChannels[i].group_id;
                            filterGroupid &&
                                store.dispatch(
                                    playFullMedia({
                                        playerstate: 'PLAYING',
                                        source: {
                                            videoid: filterGroupid,
                                        },
                                        size: {
                                          top: 0,
                                          left: 0,
                                          width: 1280,
                                          height: 720
                                        },
                                        ispreview: false,
                                        islive: true,
                                        ispip: false,
                                        showEpg: true, // AL INICIAR LA REPRODUCCIÓN SE MUESTRA LA FULLEPG
                                        filterTV: data.filterTV, // SE ENVIA EL FILTRO DE EPG
                                        event: null,
                                        playFromCard: true,
                                        playLiveFrom: LIVE_PLAY_FROM_HOME,
                                    })
                                );
                            break;
                        }
                    }
                }
                return;
            });
        return null;
    }
    if ((ribbonId === LIVECHANNEL || data.type === 'live' || data.type === 'UserLiveChannel') && group_id) {
       //Logica para validar si tenemos contratado el canal y mandar la reproduccion o alerta upsell
       const playerStreamingUtils = new PlayerStreamingUtils();
       const canPlayChannel = playerStreamingUtils.canPlayChannel(group_id);
       if (!canPlayChannel) {
         asyncPinObserver.fire('awaitpbiInfo');
         playerStreamingUtils.checkSusc(null, data.group_id, () => { }, data).then(() => {
           asyncPinObserver.fire('pbiInfocomplete');
         });
       } else {
        store.dispatch(playFullMedia({
          playerstate: 'PLAYING',
          source: {
            videoid: group_id
          },
          size: {
            top: 0,
            left: 0,
            width: 1280,
            height: 720,
          },
          ispreview: false,
          islive: true,
          ispip: false,
          showEpg: false,
          filterTV: false,
          event: null,
          playFromCard: true,
          /**
           * Considerar reemplazar la bandera de arriba con la bandera de abajo (quitar playFromCard y dejar playLiveFrom)
           */
          playLiveFrom: LIVE_PLAY_FROM_HOME
        }));
        LayersControl.hideUX();
        this.showTopRibbons();
      }
    }
    if(data.isRecord && data.actions.play && data.actions.play !== '' && !isChannelOrRecordingBlocked){
      const { modalType="" } = store.getState().modal;
      await store.dispatch(playFullMedia({
        playerstate: 'PLAYING',
        modalRecordSeriesContent: modalType === MODAL_RECORD_SERIES_CONTENT ? true :false,
      }));

      const pgmUrl = data.actions.play.smooth_streaming;

      store.dispatch(playFullMedia({
        playerstate: 'PLAYING',
        modalRecordSeriesContent: false,
        source: {
          videosource: pgmUrl
        },
        size: {
          top: 0,
          left: 0,
          width: 1280,
          height: 720
        },
        ispreview: false,
        islive: false,
        ispip: false,
        videosourceoptions: data.actions.play,
        event: null,
        npvrEvent: {...data}
      }));
      this.tryCloseModal();
    } else if(data.isSeries && data.actions.episodes && data.actions.episodes !== ''){
      await GeneralRibbonUtils.handleRecordingSeries({timeUsed: data.used, actions: data.actions, handleDeleteFromRibbonRecordings: this.props.handleDeleteFromRibbonRecordings, data: data});
    }
  }

  arrowHandler(direction, e) {
    const setStateVisibles = (value)=>{
      this.setState({ items: value });
    }
    const visible = this.state.items;
    const completeItems = this.getFilteredItems(this.props.items, this.props.type);
    const mundial = false;
    const platform = Device.getDevice().getPlatform();
    const isTizen = GeneralRibbonUtils.blockFastNavigationDownUp(platform)

    if (visible.length === 0) {
      return;
    }

    if(direction === LEFT){
      GeneralRibbonUtils.handleNavigation({
        direction: LEFT,
        e,
        visible,
        completeItems,
        setStateVisibles,
        mundial,
        visibleNumber: this.visibleNumber,
        platform: this.platform,
        noFocusDynamicBox: this.noFocusDynamicBox,
        ribbonType: this.ribbonType
      });
      this.trackContinueWatchingScrolledIfNeeded(LEFT, visible, completeItems);

    }else if(direction === RIGHT){
      GeneralRibbonUtils.handleNavigation(({
        direction: RIGHT,
        e,
        visible,
        completeItems,
        setStateVisibles,
        mundial,
        visibleNumber: this.visibleNumber,
        platform: this.platform,
        noFocusDynamicBox: this.noFocusDynamicBox,
        ribbonType: this.ribbonType
      }));

      this.trackContinueWatchingScrolledIfNeeded(RIGHT, visible, completeItems);

    }else if(direction === UP){
      const reviewHomeUp = e.target.id.includes('-away');
      reviewHomeUp && mundial && navigationUpSoccer(e);

      isTizen && GeneralRibbonUtils.handleNavigationDownUp(e, this.getDirection)

      scrollToRibbon(this.ribbonId, this.props.ribbonIds, UP)


    }else if(direction === DOWN){
      isTizen && GeneralRibbonUtils.handleNavigationDownUp(e, this.getDirection)

      scrollToRibbon(this.ribbonId, this.props.ribbonIds, DOWN)

    }
    return
  }

  dataUpdateMetrics(dataMetrics){
    const ribbonUtils = new RibbonsUtil()
    ribbonUtils.dataUpdateMetrics(dataMetrics)  }

  setBadgeType(items) {
    const linealChannels = store.getState().linealChannels;
    items && items.map((node) => {
      const { item: { type = null } } = node;
      if (type && type === "live") {
        if (linealChannels && Array.isArray(linealChannels)) {
          const { item: { group_id = null } } = node;
          const foundChannel = linealChannels.find(channel => channel.id == group_id);
          if (foundChannel) {
            foundChannel.play ? node.item.badgeType = "live_play1" : node.item.badgeType = "live_play0";
          } else {
            node.item.badgeType = "live_play0";
          }
        } else {
          node.item.badgeType = "live_play0";
        }
      } else {
        node.item.badgeType = node.item.type;
      }
    });
  }

  setValueElementMouseEnter = (element) => {
    if (this.elementoConPuntero !== element) {
      this.elementoConPuntero = element;
    }
  };
  componentDidMount() {
    SetValueElementMouseEnter.subscribe(this.setValueElementMouseEnter);
    try {
      updateContinueWatchingRenderedRoute(this.props.location);
      if (this.props.history && typeof this.props.history.listen === 'function') {
        this.unsubscribeContinueWatchingRoute = this.props.history.listen(updateContinueWatchingRenderedRoute);
      }
    } catch (error) {
      logger.error('Datadog continue watching route tracking', error);
    }
    this.trackContinueWatchingRenderedIfNeeded();
  }

  componentDidUpdate() {
    this.trackContinueWatchingRenderedIfNeeded();
  }

  componentWillUnmount() {
    // Limpiar listener del elemento previamente enfocado
    if (this._previousFocused) {
      this._previousFocused.removeEventListener('sn:willmove', this.getDirection);
      this._previousFocused = null;
    }
    SetValueElementMouseEnter.unsubscribe(this.setValueElementMouseEnter);
    try {
      if (this.unsubscribeContinueWatchingRoute) {
        this.unsubscribeContinueWatchingRoute();
      }
    } catch (error) {
      logger.error('Datadog continue watching route cleanup', error);
    }
  }

  removeHBOBanner(items = []) {
    if (!Array.isArray(items)) {
      return [];
    }

    const filteredItems = items.filter((item) => {
      const isHboBanner = item && resolveIsHBOActivation(item.type_initial_flow, item.external_activation_app, item.url);
      return !isHboBanner;
    });

    return filteredItems;
  }

  getFilteredItems(items = [], type = this.props.type) {
    if (!Array.isArray(items)) {
      return [];
    }

    if (type !== HIGHLIGHT) {
      return items;
    }

    const filteredItems = items.filter((item) => {
    const isHboBanner = item && item.external_activation_app === HBO && item.type_initial_flow !== ACTIVATION_FLOW;
      return !isHboBanner;
    });

    const { user = {} } = store.getState() || {};
    const isProfileAdmin = Boolean(user && user.admin);
    const shouldRemoveHBOBanner = !isProfileAdmin || user.statusHBO === LINKED || user.statusHBO == null;
    return shouldRemoveHBOBanner ? this.removeHBOBanner(filteredItems) : filteredItems;
  }

  isContinueWatching = () => {
    return this.isRecentActivity || isContinueWatchingRibbon({
      id: this.ribbonId,
      title: this.carruselTitle,
      url: this.props.url,
    });
  };

  trackContinueWatchingRenderedIfNeeded = () => {
    try {
      updateContinueWatchingRenderedRoute(this.props.location);

      if (hasTrackedContinueWatchingRendered || !this.isContinueWatching()) {
        return;
      }

      if (!Array.isArray(this.props.items) || this.props.items.length === 0) {
        return;
      }

      trackContinueWatchingRendered({
        ribbon: {
          id: this.ribbonId,
          title: this.carruselTitle,
          url: this.props.url,
          items: this.props.items,
        },
      });
      hasTrackedContinueWatchingRendered = true;
    } catch (error) {
      logger.error('Datadog continue watching rendered', error);
    }
  };

  trackContinueWatchingScrolledIfNeeded = (direction, visible, completeItems) => {
    try {
      if (!this.isContinueWatching()) {
        return;
      }

      trackContinueWatchingScrolled({
        ribbon: {
          id: this.ribbonId,
          title: this.carruselTitle,
          url: this.props.url,
          items: completeItems,
        },
        direction,
        visibleItemsCount: visible.length,
        totalItemsCount: completeItems.length,
      });
    } catch (error) {
      logger.error('Datadog continue watching scrolled', error);
    }
  };

  render() {
    const ignoreSeenLast = GeneralRibbonUtils.getIgnoreSeenLastByRibbonUrl(this.props.url);
    const ribbonType = this.props.type;
    const properties = {
      code: this.props.code,
      index: this.props.index,
      carruselTitle: this.carruselTitle,
      items: this.getFilteredItems(this.props.items, ribbonType),
      visibleItems: this.state.items,
      badgesUserType: this.badgesUserType,
      ignoreSeenLast: ignoreSeenLast,
      focusSettings: focusSettings,
      ribbonId: this.ribbonId,
      focusHandler: this.focusHandler,
      setMetricsEvent: this.props.setMetricsEvent,
      onClickHandler: this.clickHandler,
      hideInnerTitle: !!this.props.hideInnerTitle,
      keyDownHandler: (this.props.showFooter
        ? this.props.keyDownHandler || this.keyDownHandler
        : null),
      deleteAction: this.deleteAction,
      title: this.props.title,
      className: this.props.className,
      isRecentActivity: this.isRecentActivity,
      api: this.props.api,
      dataUpdateMetrics: this.dataUpdateMetrics,
      idTeam: this.props.idTeam,
      typeTeam: this.props.typeTeam || null,
      location: this.props.location || null,
      ribbonName: this.props.carruselTitle || null,
      device: Device.getDevice().getPlatform(),
      placeholder: this.props.placeholder,
      history: this.props.history,
      idsRibbonsUpAndDown: this.props.idsRibbonsUpAndDown,
      isMusic: this.isMusic,
      ribbonType: ribbonType,
    };

    this.setBadgeType(properties.visibleItems);

    let ribbonTypeComponent = null;
    switch (ribbonType) {
      case HIGHLIGHT:
        ribbonTypeComponent = <RibbonHighlight {...properties} />;
        break;
      case PREMIUM:
        ribbonTypeComponent = <RibbonPremium {...properties} />;
        break;
      case CATEGORY:
        ribbonTypeComponent = <RibbonCategories {...properties} history={this.props.history} />;
        break;
      case RECORDINGS:
        ribbonTypeComponent = <RibbonRecordings {...properties} />;
        break;
      case MORETOP:
        ribbonTypeComponent = <RibbonTop {...properties} />;
        break;
      case MOREPOPULAR:
        ribbonTypeComponent = <RibbonPopular {...properties} />;
        break;
      case TALENTS:
        ribbonTypeComponent = <RibbonTalent {...properties} />;
        break;
      case LIVECHANNEL:
        ribbonTypeComponent = <RibbonLiveChannel typeRender={'a'} {...properties} />;
        break;
      case VOID:
        ribbonTypeComponent = <RibbonVoid {...properties} />;
        break;
      case MUNDIALSOCCERMATCHER:
        ribbonTypeComponent = <RibbonMatcher {...properties} />;
        break;
      case MUNDIALSOCCERTEAMS:
        ribbonTypeComponent = <RibbonTeams {...properties} />;
        break;
      case MUNDIALPLAYERS:
        ribbonTypeComponent = <RibbonSoccerPlayer {...properties} />;
        break;
      case LASTVIEWEDCHANNELS:
        ribbonTypeComponent = <RibbonLastViewedChannels {...properties} />;
        break;
      case LIVEEVENTSCHANNELS:
        ribbonTypeComponent = <RibbonLiveEventsChannels {...properties} />;
      break;
      default:
        ribbonTypeComponent = <RibbonClassic {...properties} />;
    }
    return (
      <div
        id={this.ribbonId}
        ref={this.ribbonId}
        className={`ribbon ${this.props.className || ''}`}
      >
        <div className="ribbon-title">{this.props.title}</div>
        <div className={`ribbon-container`}>
          {ribbonTypeComponent}
        </div>
      </div>
    );
  }
}

const propTypes = {
  title: PropTypes.string,

  visibleNumber: PropTypes.number,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      group_id: PropTypes.string.isRequired,
      cover: PropTypes.string.isRequired,
      provider: PropTypes.string,
      format_types: PropTypes.arrayOf(PropTypes.string)
    })
  ).isRequired,

  focusHandler: PropTypes.func,
  setMetricsEvent: PropTypes.func,
  carruselTitle: PropTypes.string,
  byUser: PropTypes.bool,
  url: PropTypes.string,

  user: PropTypes.shape({
    isLoggedIn: PropTypes.bool,
    isSusc: PropTypes.bool
  })
};
Ribbon.propTypes = propTypes;

Ribbon.defaultProps = {
  title: '',
  type: null,
  visibleNumber: 5,
  focusHandler: null,
  setMetricsEvent: null,
  carruselTitle: '',
  user: {}
};

export default withRouter(Ribbon);

export { propTypes };



// WEBPACK FOOTER //
// ./src/components/RibbonNew/Ribbon.jsx